import styled, { css } from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Réplica de CustomTextField del Storybook de Velora; el foco usa el color del cliente.
const InputFieldStyled = styled.div`
.input-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .eye-icon {
    position: absolute;
    right: 15px;
    cursor: pointer;
    margin-top: 5px;
  }
}

  input {
    min-height: 40px;
    background: ${color.background.default};
    border: 1.5px solid ${color.border.default};
    box-sizing: border-box;
    border-radius: 8px;
    padding: 0 15px;
    font-family: ${tokens.typography.fontFamily.primary};
    font-weight: 400;
    font-size: 14px;
    color: ${color.text.primary};
    outline: none;
    width: 100%;
    transition: border-color 0.2s ease;

    :hover,
    :focus {
      border-color: ${props => props.theme.primary || color.brand.primary};
    }

    ::placeholder {
      font-weight: 400;
      font-size: 14px;
      color: ${color.text.disabled};
    }

    :disabled {
      color: ${color.text.disabled};
      background: ${color.background.muted};
      border-color: ${color.border.disabled};
    }

    ${props =>
      props.fontSize === 'small' &&
      css`
        line-height: 21px;
      `}
  }
`

export default InputFieldStyled
